import { PrimaryButton } from "../ButtonPrimary";
import { Modal, TModalProps } from "../Modal"

export const AfterPromotionModal = (props: TModalProps) => {


    return (
        <Modal {...props} titleStyle="w-full text-xl text-center font-bold m-5">
            <div className="max-w-large mx-auto">
                <h1 className="w-full text-xl text-center font-bold">
                    Recuerda completar el perfil de los nuevos empleados
                </h1>
                <p className="text-center font-normal text-lav-black-text w-max-medium mx-auto mt-10">
                    Deberás editar y cargar los datos faltantes para poder operar sin inconvenientes en toda la plataforma
                </p>
                <div className="w-full flex justify-center w-max-medium mx-auto mt-10">
                    <PrimaryButton
                        type="button"
                        text="Aceptar"
                        styles="bg-red-400 text-white font-bold hover:bg-opacity-80 w-1/3 align-center"
                        onClick={() => props?.onClose?.()}
                    />
                </div>
            </div>
        </Modal>
    )
}